<template>
  <div class="volunteer">
    <h2>院校专业组智能推荐</h2>
    <el-form
      :model="searchForm"
      :rules="searchFormRules"
      ref="searchFormRef"
      label-width="100px"
    >
      <!-- 选择专业批次 -->
      <el-form-item prop="piciSelectedOption">
        <el-select
          v-model="searchForm.piciSelectedOption"
          placeholder="请选择专业批次"
        >
          <el-option
            v-for="item in piciOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 首选科目 -->
      <el-form-item prop="selectedMainSubject">
        <el-select
          v-model="searchForm.selectedMainSubject"
          placeholder="请选择首选科目"
        >
          <el-option
            v-for="item in subjectNametoId.slice(0, 2)"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 再选科目 -->
      <el-form-item prop="selectedSecondSubjects">
        <el-select
          v-model="searchForm.selectedSecondSubjects"
          multiple
          placeholder="请选择再选科目"
        >
          <el-option
            v-for="item in subjectNametoId.slice(2)"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 输入分数 -->
      <el-form-item prop="weici">
        <el-input
          @keyup.native.enter="handleSearchBtnClick"
          v-model.number="searchForm.weici"
          placeholder="请输入您的位次"
        ></el-input>
      </el-form-item>
      <!-- 位次查询按钮 -->
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="handleSearchBtnClick"
        >查询</el-button
      >
    </el-form>

    <!-- 切换冲稳保区域 -->
    <div class="toggle-tab">
      <el-button
        :type="activeTab === 'frontTwenty' ? 'danger' : 'success'"
        @click="activeTab = 'frontTwenty'"
        >冲刺学校({{ Math.ceil(tableData.length * 0.2) }}所)</el-button
      >
      <el-button
        :type="activeTab === 'midThirty' ? 'danger' : 'success'"
        @click="activeTab = 'midThirty'"
        >稳妥推荐({{
          Math.ceil(tableData.length * 0.5) - Math.ceil(tableData.length * 0.2)
        }}所)</el-button
      >
      <el-button
        :type="activeTab === 'endFifty' ? 'danger' : 'success'"
        @click="activeTab = 'endFifty'"
        >保底学校({{
          tableData.length - Math.ceil(tableData.length * 0.5)
        }}所)</el-button
      >
      <el-button
        :type="activeTab === 'all' ? 'danger' : 'success'"
        @click="activeTab = 'all'"
        >所有学校({{ tableData.length }}所)</el-button
      >
    </div>

    <!-- table区域 -->
    <el-table :data="showTableData" border stripe>
      <el-table-column label="院校名称">
        <template slot-scope="scope">
          <router-link
            :to="{
              path: '/recommend/plan',
              query: {
                name: scope.row.schoolName,
                major: scope.row.majorGroup,
              },
            }"
            >{{ scope.row.schoolName }}</router-link
          >
        </template>
      </el-table-column>
      <el-table-column prop="majorGroup" label="专业组"> </el-table-column>
      <el-table-column prop="preferedSubject" label="专业类别">
      </el-table-column>
      <el-table-column prop="batch" label="专业批次"> </el-table-column>
      <el-table-column prop="year" label="年份"> </el-table-column>
      <el-table-column label="最低分/名次">
        <template slot-scope="scope">
          {{ scope.row.minScore }}分/{{ scope.row.minRank }}名次
        </template>
      </el-table-column>
    </el-table>

    <div class="footer">
      <span>数据来源:《2021年湖北省普通高校招生填报志愿参考》</span>
    </div>
  </div>
</template>
<script>
import recommend from "../../api/recommend";
export default {
  name: "School2",
  data() {
    const checkWeici = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("位次不能为空"));
      }
      if (value <= 0) {
        return callback(new Error("请输入正确位次"));
      } else {
        callback();
      }
    };
    const checkSelectedSecondSubjects = (rule, value, callback) => {
      if (!value.length) {
        return callback(new Error("请选择再选科目"));
      }
      if (value.length !== 2) {
        return callback(new Error("请选择两门再选科目"));
      } else {
        callback();
      }
    };
    return {
      piciOptions: [
        {
          value: "本科批",
          label: "本科批",
        },
        {
          value: "专科批",
          label: "专科批",
        },
        {
          value: "本科批国家专项计划",
          label: "本科批国家专项计划",
        },
      ],
      subjectNametoId: [
        { name: "物理", id: 0 },
        { name: "历史", id: 1 },
        { name: "化学", id: 2 },
        { name: "生物", id: 3 },
        { name: "思想政治", id: 4 },
        { name: "地理", id: 5 },
      ],
      subjectCollectionToCode: [
        { collection: [0, 2, 3], code: "KZ01" },
        { collection: [0, 2, 4], code: "KZ02" },
        { collection: [0, 2, 5], code: "KZ03" },
        { collection: [0, 3, 4], code: "KZ04" },
        { collection: [0, 3, 5], code: "KZ05" },
        { collection: [0, 4, 5], code: "KZ06" },
        { collection: [1, 2, 3], code: "KZ07" },
        { collection: [1, 2, 4], code: "KZ08" },
        { collection: [1, 2, 5], code: "KZ09" },
        { collection: [1, 3, 4], code: "KZ10" },
        { collection: [1, 3, 5], code: "KZ11" },
        { collection: [1, 4, 5], code: "KZ12" },
      ],
      searchForm: {
        piciSelectedOption: "",
        selectedMainSubject: "",
        selectedSecondSubjects: [],
        weici: "",
      },
      searchFormRules: {
        piciSelectedOption: [
          { required: true, message: "请选择专业批次", trigger: "blur" },
        ],
        selectedMainSubject: [
          { required: true, message: "请选择首选科目", trigger: "blur" },
        ],
        selectedSecondSubjects: [
          { validator: checkSelectedSecondSubjects, trigger: "blur" },
        ],
        weici: [{ validator: checkWeici, trigger: "blur" }],
      },
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        wc: "",
        typeName: "",
        batchName: "",
        code: "", // 专业组代码
      },
      tableData: [],
      activeTab: "all",
    };
  },
  computed: {
    showTableData() {
      if (this.activeTab === "all") {
        return this.tableData;
      } else if (this.activeTab === "frontTwenty") {
        const frontTwenty_end = Math.ceil(this.tableData.length * 0.2);
        return this.tableData.slice(0, frontTwenty_end);
      } else if (this.activeTab === "midThirty") {
        const midThirty_start = Math.ceil(this.tableData.length * 0.2);
        const midThirty_end = Math.ceil(this.tableData.length * 0.5);
        return this.tableData.slice(midThirty_start, midThirty_end);
      } else if (this.activeTab === "endFifty") {
        const endFifty_start = Math.ceil(this.tableData.length * 0.5);
        return this.tableData.slice(endFifty_start);
      }
    },
  },
  created() {
    // 判断是路由跳转进入还是正常进入
    // 如果正常进入，$route.query为空，stringify后得到'{}'
    if (JSON.stringify(this.$route.query).length !== 2) {
      this.queryInfo.wc = this.$route.query.wc;
      this.queryInfo.typeName = this.$route.query.typeName;
      this.queryInfo.batchName = this.$route.query.batchName;
      this.queryInfo.code = this.$route.query.code;

      this.searchForm.piciSelectedOption = this.queryInfo.batchName;
      this.searchForm.selectedMainSubject = this.subjectCollectionToCode.find(
        (item) => item.code === this.queryInfo.code
      ).collection[0];
      this.searchForm.selectedSecondSubjects = this.subjectCollectionToCode
        .find((item) => item.code === this.queryInfo.code)
        .collection.slice(1);
      this.searchForm.weici = this.queryInfo.wc;
    }
    this.getTableData();
  },
  methods: {
    async getTableData() {
      const res = await recommend.recommend(this.queryInfo);
      console.log(res);
      this.tableData = res.list;
    },
    handleSearchBtnClick() {
      this.$refs.searchFormRef.validate((valid) => {
        if (valid) {
          this.queryInfo.wc = this.searchForm.weici;
          this.queryInfo.batchName = this.searchForm.piciSelectedOption;
          this.queryInfo.typeName = this.searchForm.selectedMainSubject
            ? "历史类"
            : "物理类";
          this.queryInfo.code = this.subjectCollectionToCode.find((item) => {
            return (
              [
                this.searchForm.selectedMainSubject,
                ...this.searchForm.selectedSecondSubjects,
              ]
                .sort()
                .join() === item.collection.join()
            );
          }).code;
          console.log(this.queryInfo);
          this.getTableData();
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
div.volunteer {
  height: 100%;
  overflow: auto;
}

.volunteer h2 {
  text-align: center;
  background-size: cover;
  font-weight: 400;
  height: 80px;
  background-image: url("../../assets/img/bk2.png");
  line-height: 80px;
  font-size: 30px;
  color: #fff;
  letter-spacing: 10px;
  margin-bottom: 30px;
}

.el-form {
  display: flex;
}

.el-form .el-button {
  height: 40px;
  margin-left: 10px;
}

div.toggle-tab {
  margin: 20px 0 30px;
  padding-left: 100px;
}

.el-table {
  width: 88%;
  margin: 0 auto;
}

.el-table a {
  color: #000;
}

.footer {
  margin: 20px 82px 0 0;
}

.footer span {
  float: right;
  color: #ccc;
  font-size: 12px;
}
</style>